<template>
    <span>
        <el-button type="primary" plain size="mini" @click="dialogVisible = true">Edit</el-button>
        <el-dialog title="Edit Feature" :visible.sync="dialogVisible">
            <app-placeholder-horizontal :imageId="feature.image_id" @upload="onUpload"/>
            <el-form :model="form" ref="form" @submit.prevent.native="onSubmit('form')">
                <el-form-item label="Title" prop="title">
                    <el-input v-model="form.title" placeholder="Enter product feature title"></el-input>
                </el-form-item>
                <el-form-item label="Description" prop="desc">
                    <el-input v-model="form.desc" placeholder="Enter product feature description" type="textarea" rows="5"></el-input>
                </el-form-item>
                <el-button native-type="submit" type="primary" :loading="loading">Save</el-button>
            </el-form>
        </el-dialog>
    </span>
</template>

<script>
import AppPlaceholderHorizontal from '@/components/App/AppPlaceholderHorizontal'

export default {
    components: {
        AppPlaceholderHorizontal,
    },

    data() {
        return {
            loading: false,
            dialogVisible: false,
            form: {
                desc: this.feature.desc,
                title: this.feature.title,
            },
            rules: {
                'desc': [
                    { required: true, message: 'Enter a product feature description.', trigger: 'blur' },
                    { min: 140, max: 280, message: 'Length should be 140 to 280.', trigger: 'blur' },
                ],
                'title': [
                    { required: true, message: 'Enter a product feature title.', trigger: 'blur' },
                ],
            },
        }
    },

    props: {
        feature: {
            required: true,
            type: Object,
        },
    },

    methods: {
        onSubmit(form) {
            this.loading = true

            this.$refs[form].validate(async valid => {
                if (!valid) {
                    this.loading = false

                    return false
                }

                try {
                    var { data } = await this.$http.put(`/product-features/${ this.feature.id }`, {
                        desc: this.form.desc,
                        title: this.form.title,
                    })
                } catch(err) {
                    this.$message.error(err.response.data.message)

                    return false
                } finally {
                    this.loading = false
                }

                this.$emit('update')
                this.$message.success(data.message)
                this.dialogVisible = false
            })
        },

        async onUpload(imageId) {
            this.loading = true

            try {
                var { data } = await this.$http.put(`/product-features/${ this.feature.id }/image`, {
                    image_id: imageId,
                })
            } catch(err) {
                this.$message.error(err.response.data.message)

                return false
            } finally {
                this.loading = false
            }

            this.form.imageId = imageId
            this.$message.success(data.message)
        },
    },
}
</script>
